import { Col, Row } from "react-bootstrap";
import { useAppSelector } from "../../../../../hooks";
import { selectAgreeData } from "../../../../../redux/reducer/agree/agreeSliceCreate";
import FormClientIndex from "../../../../client/form/view/Index";
import FormItemIndex from "../../../../item/form/view/Index";
import AgreeForm from "../../../../agree/agreeP/form/edit/count/AgreeForm";
import { Fragment } from "react";

//redux

//view->
// import AgreeClientEdit from "./edit/AgreeClientEdit";
// import AgreeImageView from "./AgreeImageView";
//view->before
// import AgreeAgreeViewUP from "./agreeP/AgreeAgreeViewUP";
//view->after
// import AgreeAgreeViewUS from "./agreeS/AgreeAgreeViewUS";
//edit->before
// import AgreeAgreeEditUP from "./agreeP/AgreeAgreeEditUP";
//edit->after
// import AgreeAgreeEditUS from "./agreeS/AgreeAgreeEditUS";

//-------------------------------------------------------------------

export default function AgreeIndex() {
    //redux
    const { client, item } = useAppSelector(selectAgreeData);

    //view
    return (
        <Row>
            <Col xs={3}>
                <FormClientIndex client={client} />
            </Col>
            <Col xs={4}>
                {item.map((obj, inx) => (
                    <Fragment key={inx}>
                        <FormItemIndex item={obj} />
                    </Fragment>
                ))}
            </Col>
            <Col xs={5}>
                <AgreeForm />
            </Col>
        </Row>
    );
}
